import * as React from 'react';
export default function SvgDocument() {
  return /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    height: "1em",
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.96 8.83c0-.41.33-.75.75-.75h4.54a.75.75 0 0 1 0 1.5H9.7a.75.75 0 0 1-.75-.75Zm.74 2.42a.75.75 0 0 0 0 1.5h4.55a.75.75 0 0 0 0-1.5H9.7Zm0 3.17a.75.75 0 0 0 0 1.5h4.55a.75.75 0 0 0 0-1.5H9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.75 4a2.74 2.74 0 0 0-2.74 2.74v10.52A2.74 2.74 0 0 0 7.75 20h8.5a2.74 2.74 0 0 0 2.74-2.74V6.74A2.74 2.74 0 0 0 16.25 4h-8.5ZM6.51 6.74c0-.68.55-1.24 1.24-1.24h8.5c.69 0 1.24.56 1.24 1.24v10.52c0 .68-.55 1.24-1.24 1.24h-8.5c-.69 0-1.24-.56-1.24-1.24V6.74Z",
    clipRule: "evenodd"
  }));
}